{
  "steps": {
    "organization": "Organization",
    "setupPath": "Connect data",
    "instructions": "Instructions"
  },
  "connectTelemetry": {
    "title": "Connect your telemetry",
    "lead": "Choose OpenTelemetry for Mezmo analysis, or use another source in Pipeline.",
    "addMoreLater": "You can add more sources later.",
    "setupOtel": "Set up OpenTelemetry",
    "setupPipeline": "Set up Pipeline",
    "error": "Unable to create pipeline.",
    "otel": {
      "recommended": "Recommended",
      "title": "Use OpenTelemetry",
      "description": "Get Data Insights, anomaly detection, and AI Investigations.",
      "chips": {
        "logInsights": "Log Insights",
        "anomaly": "Anomaly detection",
        "traceInsights": "Trace Insights",
        "aiInvestigations": "AI Investigations",
        "metricsInsights": "Metrics Insights"
      }
    },
    "pipeline": {
      "title": "Use another Pipeline source",
      "description": "Choose from 20+ sources for collection, transformation, and routing.",
      "note": "Mezmo analysis requires OpenTelemetry."
    }
  },
  "createOrg": {
    "title": "Name your organization",
    "lead": "This groups your services, telemetry, and teammates. You can change it later in settings.",
    "orgNameLabel": "Organization name",
    "orgNamePlaceholder": "Acme Industries",
    "orgNameHint": "Up to {{max}} characters",
    "submit": "Create Organization",
    "creatingTitle": "Creating {{org}}",
    "creatingLead": "Provisioning your account and first pipeline.",
    "createdTitle": "{{org}} created",
    "createdLead": "Your organization has been created successfully.",
    "next": "Next: connect your data",
    "defaultOrgLabel": "Your organization",
    "pendingOrgWarning": "You already have an organization in a pending state. Please complete the setup of your existing organization before creating a new one.",
    "continueSetup": "Continue setup",
    "error": "Unable to create organization."
  },
  "setupPath": {
    "title": "How will you send data?",
    "lead": "Pick the path that matches your setup.",
    "showInstructions": "Show instructions",
    "headerHintBefore": "These instructions are always available in the Mezmo app's header, under the",
    "headerHintAfter": "icon.",
    "paths": {
      "new": {
        "title": "New collector",
        "description": "Run otelcol-contrib on a host or VM"
      },
      "helm": {
        "title": "New collector via Helm chart",
        "description": "Deploy into a Kubernetes cluster"
      },
      "existing": {
        "title": "Existing collector",
        "description": "Add the Mezmo exporter to a config you already run"
      },
      "demo": {
        "title": "OpenTelemetry Demo",
        "description": "Send sample telemetry from the demo app"
      }
    }
  },
  "instructions": {
    "lead": "Follow these configuration steps. Mezmo will begin processing your data as soon as the collector is started.",
    "endpoint": "Endpoint",
    "apikeyHeader": "apikey header",
    "back": "Back",
    "goToDashboard": "Go to Dashboard",
    "goToLogInsights": "Go to Log Insights",
    "waiting": "Listening for your first logs, metrics, and traces — this page updates on its own.",
    "received": "Data received! Your telemetry is flowing into your pipeline.",
    "copy": "Copy",
    "copied": "Copied to clipboard",
    "dataStartsFlowingTitle": "Data starts flowing",
    "dataStartsFlowingLead": "The Collector will start sending logs, metrics and traces to your Pipeline.",
    "titles": {
      "new": "Install a new collector",
      "helm": "Install via Helm chart",
      "existing": "Update your existing collector",
      "demo": "Run the OpenTelemetry Demo"
    },
    "newCollector": {
      "download": "Download the collector",
      "downloadLeadBefore": "Grab the",
      "downloadLeadAfter": "build for your environment from the",
      "downloadLeadLink": "OpenTelemetry releases page",
      "createConfig": "Create a config.yaml",
      "setKey": "Set your ingestion key",
      "start": "Start the collector"
    },
    "helm": {
      "lead": "Install the collector directly in a Kubernetes cluster. It runs as a DaemonSet, tails pod logs, exposes an in-cluster OTLP endpoint, and forwards everything to Mezmo.",
      "addRepo": "Add the OpenTelemetry Helm repo",
      "createSecret": "Create a namespace and key secret",
      "createValues": "Create a values.yaml",
      "createValuesLead": "This example gives you an OTLP source inside your cluster and exports your telemetry to Mezmo.",
      "install": "Install the chart"
    },
    "existing": {
      "addExporter": "Add the Mezmo exporter",
      "addExporterLeadBefore": "Add this block to the",
      "addExporterLeadMiddle": "section of your existing collector config, then add",
      "addExporterLeadAfter": "to each pipeline you want to forward.",
      "restart": "Restart the collector"
    },
    "demo": {
      "clone": "Clone the demo",
      "addExporter": "Add the Mezmo exporter",
      "addExporterLeadBefore": "Open",
      "addExporterLeadAfter": "and add the following configuration.",
      "start": "Start the demo",
      "verify": "Verify the web store and telemetry"
    }
  }
}
